import { createApi } from '@reduxjs/toolkit/query/react';
import { getRtkConfig } from '@shared/config';
import type { Event } from 'library/models/events';
import { eventsApi } from './api';

const eventApi = createApi({
  reducerPath: 'eventsQuery',
  baseQuery: getRtkConfig(eventsApi),
  tagTypes: ['events'],

  endpoints: (build) => ({
    getEventById: build.query<Event, number>({
      query: (id) => ({
        url: `${id}`,
        method: 'GET',
      }),
    }),
  }),
});

export const eventApiReducer = eventApi.reducer;
export const eventApiReducerPath = eventApi.reducerPath;
export const eventApiMiddleware = eventApi.middleware;

export const { useGetEventByIdQuery } = eventApi;
